import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

// recommendation is kept outside getInitialState.list()'s {byId, data, item}
// shape -- that helper is shared by many unrelated reducers, and this slice
// belongs only here.
const initialState = { ...getInitialState.list(), recommendation: null };

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.AUDIT_GROUP_ITEM_ADD: {
            return { ...state, item: getInitialState.auditGroup() };
        }
        case actionTypes.AUDIT_GROUP_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.AUDIT_GROUP_ITEM_SET: {
            const { auditGroup } = action.payload;
            return { ...state, item: auditGroup };
        }
        case actionTypes.AUDIT_GROUP_ITEM_UPDATE: {
            const { auditGroup } = action.payload;
            const { item } = state;
            return { ...state, item: { ...item, ...auditGroup } };
        }
        case actionTypes.AUDIT_GROUPS_CLEAR: {
            return { ...initialState };
        }
        case actionTypes.AUDIT_GROUPS_GET_REQUEST: {
            return { ...getInitialState.list(), recommendation: state.recommendation };
        }
        case actionTypes.AUDIT_GROUPS_GET_SUCCESS: {
            const { auditGroups } = action.payload;
            return helpers.getListReducer(state, auditGroups);
        }
        case actionTypes.AUDIT_GROUP_POST_SUCCESS: {
            const { auditGroup } = action.payload;
            return helpers.getListItemReducer(state, auditGroup);
        }
        case actionTypes.AUDIT_GROUP_PATCH_SUCCESS: {
            const { auditGroup } = action.payload;
            return helpers.updateListReducer(state, auditGroup);
        }
        case actionTypes.AUDIT_GROUP_RECOMMENDATION_GET_REQUEST: {
            return { ...state, recommendation: null };
        }
        case actionTypes.AUDIT_GROUP_RECOMMENDATION_GET_SUCCESS: {
            const { recommendation } = action.payload;
            return { ...state, recommendation };
        }
        case actionTypes.AUDIT_GROUP_RECOMMENDATION_GET_FAILURE:
        case actionTypes.AUDIT_GROUP_RECOMMENDATION_CLEAR: {
            return { ...state, recommendation: null };
        }
        default: {
            return state;
        }
    }
}
